
import { Component } from '@theme/component';

class InlineProductCarousel extends Component {
  requiredRefs = ['swiper'];

  #swiper = null;

  connectedCallback() {
    super.connectedCallback();

    this.#initCarousel();
  }

  #initCarousel() {
    const {buttonPrefix} = this.dataset;

    const navigation = {
      prevEl: buttonPrefix ? `.${buttonPrefix}-swiper-button-prev` : null,
      nextEl: buttonPrefix ? `.${buttonPrefix}-swiper-button-next` : null,
    }

    this.#swiper = new window.Swiper(this.refs.swiper, {
      navigation,
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 40,
        }
      }
    });
  }
}

if (!customElements.get('inline-product-carousel')) {
  customElements.define('inline-product-carousel', InlineProductCarousel);
}